module.exports = __webpack_public_path__ + "img/mobile scanner stand52.c9f036ad.jpg";